/**
 * @module 易花花极速版iOS相关模块路由
 */
export default [
  {
    path: '/byb/mine/service',
    name: 'byb_mine_service',
    component: () => import('@/pages/app/byb-app/mine/service.vue'),
    meta: {
      title: '我的客服'
    }
  },
  {
    path: '/byb/protocol/register',
    name: 'byb_protocol_register',
    component: () => import('@/pages/app/byb-app/protocol/register.vue'),
    meta: {
      title: '用户服务协议'
    }
  },
  {
    path: '/byb/protocol/private',
    name: 'byb_protocol_private',
    component: () => import('@/pages/app/byb-app/protocol/private.vue'),
    meta: {
      title: '用户隐私保护政策'
    }
  }
]
